import { render, staticRenderFns } from "./Campana.vue?vue&type=template&id=4f112cf3&"
import script from "./Campana.vue?vue&type=script&lang=js&"
export * from "./Campana.vue?vue&type=script&lang=js&"
import style0 from "./Campana.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports